module.exports = __webpack_public_path__ + "03_face.08615469.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/03_face.png
// module id = RaKc
// module chunks = 0